import { render, staticRenderFns } from "./RamsSignatureRequest.vue?vue&type=template&id=680250e4&"
import script from "./RamsSignatureRequest.vue?vue&type=script&lang=js&"
export * from "./RamsSignatureRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports